import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-email-options',
  templateUrl: './email-options.component.html',
  styleUrls: ['./email-options.component.scss']
})
export class EmailOptionsComponent {

}

